module.exports = __webpack_public_path__ + "images/get-credit-bg-1a207cfb.svg";